(ns dashboard.views.settings.password
  (:require
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   [dashboard.components.button :refer [button]]))

(defn content []
  [:div.divide-y.divide-gray-200
   [:div.py-6.px-4.sm:p-6.lg:pb-8
    [:div.grid.grid-cols-12.gap-6
     [:div.col-span-12.sm:col-span-6
      [:label.block.text-sm.font-medium.text-gray-700
       {:for "new-password"}
       "New Password"]
      [:input#password.mt-1.block.w-full.border.border-gray-300.rounded-md.shadow-sm.py-2.px-3.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.sm:text-sm
       {:auto-complete "password"
        :name "new-password"
        :type "password"}]]
     [:div.col-span-12.sm:col-span-6]
     [:div.col-span-12.sm:col-span-6
      [:label.block.text-sm.font-medium.text-gray-700
       {:for "new-password-repeat"}
       "New Password (Repeat)"]
      [:input#new-password.mt-1.block.w-full.border.border-gray-300.rounded-md.shadow-sm.py-2.px-3.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.sm:text-sm
       {:auto-complete "password"
        :name "new-password-repeat"
        :type "password"}]]
     [:div.col-span-12.sm:col-span-6]]]
   [:div.divide-y.divide-gray-200
    [:div.py-4.px-4.flex.justify-end.sm:px-6
     [button
      {:type "submit"}
      (tr :action/save)]]]])
